import { render, staticRenderFns } from "./AbkSurveyStatsBoxAnswers.vue?vue&type=template&id=337c7200&scoped=true&"
import script from "./AbkSurveyStatsBoxAnswers.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyStatsBoxAnswers.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyStatsBoxAnswers.vue?vue&type=style&index=0&id=337c7200&scoped=true&lang=scss&"
import style1 from "./AbkSurveyStatsBoxAnswers.vue?vue&type=style&index=1&id=337c7200&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337c7200",
  null
  
)

export default component.exports